import { MessagesCenterQueue } from '../../models/messages-center-queue.model';

export class SetMessagesCenterQueueId {
  static readonly type = '[MessagesCenterQueue] Set queueId';

  constructor(public payload: MessagesCenterQueue) {
  }
}

